export const FRAUD_ASSESSMENT_PROMPT = "Carry out a fraud assessment on this customer's recent activity";

export const FRAUD_ASSESSMENT_FALLBACK_DEPARTMENT = 'Customer Support';
